<template>
  <v-hover v-slot:default="{ hover }">
    <v-card
      height="340"
      width="240"
      class="shadow ubuntu half-radius"
      :class="{ 'custom-card-active': hover }"
    >
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <v-container>
              <v-row align="center" justify="center">
                <v-avatar size="76" class="align-self-center">
                  <template>
                    <v-img v-if="item.avatar" :src="item.avatar" />
                    <v-icon v-else dark>mdi-account-circle</v-icon>
                  </template>
                </v-avatar>
              </v-row>
              <v-row align="center" justify="center" class="my-5 text-break" style="height: 3rem">
                <span class="headline custom-text text-center">{{
                  `${item.first_name} ${item.last_name}`
                }}</span>
              </v-row>
              <v-row align="center" justify="center" class="flex-wrap">
                <span class="grey--text text--darken-2 body-2">Email</span>
              </v-row>
              <v-row align="center" justify="center" style="height: 2rem" class="text-break">
                <span class="custom-text body-1 text-center">{{ item.email }}</span>
              </v-row>
            </v-container>
          </v-col>
          <v-btn
            @click="action(item)"
            depressed
            small
            :disabled="buttonDisabled"
            width="100"
            class="text-capitalize caption white--text"
            color="#FF347C"
          >
            <slot name="buttonText">Select</slot>
          </v-btn>
        </v-row>
      </v-container>
    </v-card>
  </v-hover>
</template>
<script>
export default {
  props: {
    item: {
      required: true,
      type: Object,
    },
    action: {
      required: true,
      type: Function,
    },
    disable: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  computed: {
    buttonDisabled() {
      if (
        this.disable &&
        this.$store.getters["admin/teacher"] &&
        this.$store.getters["admin/teacher"].students.includes(this.item.email)
      )
        return true;
      return false;
    },
  },
};
</script>
